import { Dimensions, PixelRatio, Platform } from 'react-native';
const { getPixelSizeForLayoutSize } = PixelRatio;
const ratio = PixelRatio.get();
export const deviceHeight = Dimensions.get('window').height;
export const deviceWidth = Dimensions.get('window').width;
const platform = Platform.OS;
const platformStyle = undefined;
const responsiveBrakePoints = {
    xsBrakePint: 544,
    smBrakePint: 768,
    mdBrakePint: 992,
    lgBrakePint: 1200,
};
const fonts = Platform.select({
    web: {
        regular: 'Guillon-Regular, Roboto, Helvetica, Neue, Helvetica, Arial, sans-serif',
        medium: 'Guillon-Medium, Roboto-Medium, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
        light: 'Guillon-Light, Roboto-Light, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
        thin: 'Guillon-Thin, Roboto-Thin, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
        black: 'Guillon-Black, Roboto-Black, Helvetica Neue, Helvetica, Arial, sans-serif',
        italic: 'Guillon-Italic, Roboto-Black, Helvetica Neue, Helvetica, Arial, sans-serif',
        bold: 'Guillon-Bold, Roboto-Bold, Helvetica Neue, Helvetica, Arial, sans-serif',
    },
    ios: {
        regular: 'Guillon-Regular',
        medium: 'Guillon-Medium',
        light: 'Guillon-Light',
        thin: 'Guillon-Thin',
        black: 'Guillon-Black',
        bold: 'Guillon-Bold',
    },
}) || {
    regular: 'Guillon-Regular',
    medium: 'Guillon-Medium',
    light: 'Guillon-Light',
    thin: 'Guillon-Thin',
    black: 'Guillon-Black',
    bold: 'Guillon-Bold',
};
export const headingStyles = (size) => {
    switch (size) {
        case 6:
            return {
                fontSize: getPixelSizeForLayoutSize(12) / ratio,
                lineHeight: getPixelSizeForLayoutSize(30) / ratio,
            };
        case 5:
            return {
                fontSize: getPixelSizeForLayoutSize(14) / ratio,
                lineHeight: getPixelSizeForLayoutSize(30) / ratio,
            };
        case 4:
            return {
                fontSize: getPixelSizeForLayoutSize(16) / ratio,
                lineHeight: getPixelSizeForLayoutSize(30) / ratio,
            };
        case 3:
            return {
                fontSize: getPixelSizeForLayoutSize(18) / ratio,
                lineHeight: getPixelSizeForLayoutSize(35) / ratio,
            };
        case 2:
            return {
                fontSize: getPixelSizeForLayoutSize(24) / ratio,
                lineHeight: getPixelSizeForLayoutSize(35) / ratio,
            };
        case 1:
        default:
            return {
                fontSize: getPixelSizeForLayoutSize(30) / ratio,
                lineHeight: getPixelSizeForLayoutSize(35) / ratio,
            };
    }
};
export default Object.assign(Object.assign({ platformStyle,
    platform }, responsiveBrakePoints), { 
    // Color Guide
    DarkText: '#21262C', MediumText: '#949AA6', LightText: '#BCC0C7', ModalDividerLine: '#E7F1F9', FormElements: '#CCD0D9', Background: '#ECEDF2', LightBackground: '#F4F5F9', LightGreen: '#CFFFEA', BrighteGreen: '#00D299', GreenShadow: '#00BF74', DarkGreen: '#006F43', BrighteBlue: '#497FEC', BlueShadow: '#2F57A9', Turquoise: '#4FC5D0', AlertRed: '#FF4A46', LightRed: '#FFECEC', Yellow: '#FFB52B', LightYellow: '#FFF9E8', WhiteColor: '#FFFFFF', BlackColor: '#000000', GreyLoaderColor: '#838A8A', BlackLoaderColor: '#444D4D', ElevationColor: ' #21262C3D', disabledGreenButtonColor: '#98ECCB', // TODO not in color guid but in actual button sample, need to ask Hussian
    // State colors
    get colorInputActive() {
        return this.GreenShadow;
    },
    get colorInputHover() {
        return this.LightBackground;
    },
    get hoverGreenButtonColor() {
        return this.GreenShadow;
    },
    get hoverGreyButtonColor() {
        return this.FormElements;
    },
    get colorDivider() {
        return this.FormElements;
    },
    get elevationColor() {
        return this.ElevationColor;
    },
    // gap
    get fieldBottomGap() {
        return this.thirtyPT;
    },
    // size
    get textInputIconSize() {
        return this.thirtyPT;
    },
    get borderRadius() {
        return this.fourPT;
    },
    get borderWidth() {
        return this.onePT;
    },
    get textInputHeight() {
        return this.sixtyPT;
    },
    get textInputGroupHeight() {
        return this.oneHunredEight;
    },
    get inputHeight() {
        return this.fortyFivePT;
    },
    get tableHeight() {
        return this.fiftyPT;
    },
    get blockBorderRadius() {
        return this.fourPT;
    },
    get buttonHeight() {
        return this.sixtyPT;
    },
    get checkboxSize() {
        return this.twentySixPT;
    },
    get labelSize() {
        return this.fifteenPT;
    },
    get valueSize() {
        return this.twentyPT;
    }, 
    // Android
    androidRipple: true, androidRippleColor: 'rgba(256, 256, 256, 0.3)', androidRippleColorDark: 'rgba(0, 0, 0, 0.15)', btnUppercaseAndroidText: true, 
    // Date Picker
    datePickerBg: 'transparent', 
    // Loader
    defaultLoaderSize: 36.74, lightOverlayBackground: 'rgba(255, 255, 255, 0.8)', darkOverlayBackground: 'rgba(33, 38, 44, 0.8)', 
    // Font size
    get subTextFontSize() {
        return this.fourteenPT;
    },
    get textLineFontSize() {
        return this.thirtyPT;
    },
    get buttonFontSize() {
        return this.twentyFourPT;
    },
    get titleFontSize() {
        return this.thirtyPT;
    },
    get textFontSize() {
        return this.eighteenPT;
    },
    get labelFontSize() {
        return this.sixteenPT;
    },
    get helpText() {
        return this.fifteenPT;
    },
    get errorFontSize() {
        return this.sixteenPT;
    },
    get subtitleFontSize() {
        return this.eighteenPT;
    },
    get textInputFontSize() {
        return this.twentyPT;
    },
    get headLineFontSize() {
        return this.thirtyFourPT;
    },
    get checkBoxTextLineHeight() {
        return this.twentyFourPT;
    },
    get lineHeightFontSize() {
        return this.fortyFivePT;
    },
    get labeLineHeightFontSize() {
        return this.eighteenPT;
    },
    get titleLineHeightFontSize() {
        return this.thirtySevenPT;
    },
    get bulletPoint() {
        return this.fortyFivePT;
    },
    get pointLineHeight() {
        return this.twentySixPT;
    },
    get subHeadingLineHeight() {
        return this.thirtyPT;
    },
    get tableTotalLineHeight() {
        return this.sixtyPT;
    }, 
    // Icon
    iconFamily: 'Ionicons', iconFontSize: platform === 'ios' ? 30 : 28, iconHeaderSize: platform === 'ios' ? 33 : 24, 
    // Font
    fonts,
    // heading size
    headingStyles, 
    // TO DO
    onePT: getPixelSizeForLayoutSize(1) / ratio, twoPT: getPixelSizeForLayoutSize(2) / ratio, threePT: getPixelSizeForLayoutSize(3) / ratio, fourPT: getPixelSizeForLayoutSize(4) / ratio, fivePT: getPixelSizeForLayoutSize(5) / ratio, sixPT: getPixelSizeForLayoutSize(6) / ratio, eightPT: getPixelSizeForLayoutSize(8) / ratio, tenPT: getPixelSizeForLayoutSize(10) / ratio, thirteenPT: getPixelSizeForLayoutSize(13) / ratio, fourteenPT: getPixelSizeForLayoutSize(14) / ratio, fifteenPT: getPixelSizeForLayoutSize(15) / ratio, sixteenPT: getPixelSizeForLayoutSize(16) / ratio, seventeenPT: getPixelSizeForLayoutSize(17) / ratio, eighteenPT: getPixelSizeForLayoutSize(18) / ratio, twentyPT: getPixelSizeForLayoutSize(20) / ratio, twentyThreePT: getPixelSizeForLayoutSize(23) / ratio, twentyTwoPT: getPixelSizeForLayoutSize(22) / ratio, twentyFourPT: getPixelSizeForLayoutSize(24) / ratio, twentyFivePT: getPixelSizeForLayoutSize(25) / ratio, twentySixPT: getPixelSizeForLayoutSize(26) / ratio, thirtyPT: getPixelSizeForLayoutSize(30) / ratio, thirtyFourPT: getPixelSizeForLayoutSize(34) / ratio, thirtySevenPT: getPixelSizeForLayoutSize(37) / ratio, thirtyEightPT: getPixelSizeForLayoutSize(38) / ratio, fortyPT: getPixelSizeForLayoutSize(40) / ratio, fortyTwoPT: getPixelSizeForLayoutSize(42) / ratio, fortyFivePT: getPixelSizeForLayoutSize(45) / ratio, fiftyPT: getPixelSizeForLayoutSize(50) / ratio, fiftyFivePT: getPixelSizeForLayoutSize(55) / ratio, sixtyPT: getPixelSizeForLayoutSize(60) / ratio, sixtyFivePT: getPixelSizeForLayoutSize(65) / ratio, seventyPT: getPixelSizeForLayoutSize(70) / ratio, eightyPT: getPixelSizeForLayoutSize(80) / ratio, eightyTwoPT: getPixelSizeForLayoutSize(82) / ratio, hunredPT: getPixelSizeForLayoutSize(100) / ratio, hunredThirtyPT: getPixelSizeForLayoutSize(130) / ratio, oneHunredEight: getPixelSizeForLayoutSize(108) / ratio, threeHundredPT: getPixelSizeForLayoutSize(300) / ratio, fiveHundredPT: getPixelSizeForLayoutSize(500) / ratio, fourHundredFiftyPT: getPixelSizeForLayoutSize(450) / ratio });
